import "react-app-polyfill/ie11";
import "react-app-polyfill/ie9";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./store";
import { Provider as RollbarProvider, ErrorBoundary as RollbarErrorBoundary } from '@rollbar/react'
import "./styles/main.less";
import { askForPermissionToReceiveNotification } from "./firebase";
import { rollbarConfig } from "./util/configs";
import { stashOrderingForFromUrl } from "./util/helpers/deskOrderingFor";
import { startDeskCartStatus } from "./util/helpers/deskCartStatus";
import { startDeskPaymentStatus } from "./util/helpers/deskPaymentStatus";
import { applyDeskPanelLook } from "./util/helpers/deskPanelLook";

// Desk build: compact Route Desk look, only inside Route Desk's panel.
applyDeskPanelLook();

// Desk build: keep ?ordering_for= before the login redirects drop the query.
stashOrderingForFromUrl(window.location.search);
// Desk build: tell an embedding Route Desk what is in the cart.
startDeskCartStatus(store);
// Desk build: tell an embedding Route Desk whether a payment is being checked.
startDeskPaymentStatus(store);

const ErrorDisplay = ({ error, resetError }) => ( // <-- props passed to fallbackUI component
  <div>
    <h1>A following error has occured:</h1>
    <p>{error.toString()}</p>
  </div>
);

ReactDOM.render(
	<RollbarProvider config={rollbarConfig}>
		<RollbarErrorBoundary fallbackUI={ErrorDisplay}>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<App />
				</PersistGate>
			</Provider>
		</RollbarErrorBoundary>
	</RollbarProvider>,
	document.getElementById("root")
);

askForPermissionToReceiveNotification();
